var cov_1ygda8arzu = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/utils/dom/normalizeWheel.ts",
      hash = "4537c3a9aa359f3acaa86896f61a4ffd8befde23",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/utils/dom/normalizeWheel.ts",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 19
        },
        end: {
          line: 1,
          column: 21
        }
      },
      "1": {
        start: {
          line: 2,
          column: 20
        },
        end: {
          line: 2,
          column: 22
        }
      },
      "2": {
        start: {
          line: 3,
          column: 20
        },
        end: {
          line: 3,
          column: 23
        }
      },
      "3": {
        start: {
          line: 4,
          column: 21
        },
        end: {
          line: 4,
          column: 24
        }
      },
      "4": {
        start: {
          line: 17,
          column: 11
        },
        end: {
          line: 17,
          column: 12
        }
      },
      "5": {
        start: {
          line: 18,
          column: 11
        },
        end: {
          line: 18,
          column: 12
        }
      },
      "6": {
        start: {
          line: 19,
          column: 11
        },
        end: {
          line: 19,
          column: 12
        }
      },
      "7": {
        start: {
          line: 20,
          column: 11
        },
        end: {
          line: 20,
          column: 12
        }
      },
      "8": {
        start: {
          line: 22,
          column: 2
        },
        end: {
          line: 24,
          column: 3
        }
      },
      "9": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 23,
          column: 21
        }
      },
      "10": {
        start: {
          line: 25,
          column: 2
        },
        end: {
          line: 27,
          column: 3
        }
      },
      "11": {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 26,
          column: 41
        }
      },
      "12": {
        start: {
          line: 28,
          column: 2
        },
        end: {
          line: 30,
          column: 3
        }
      },
      "13": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 29,
          column: 42
        }
      },
      "14": {
        start: {
          line: 31,
          column: 2
        },
        end: {
          line: 33,
          column: 3
        }
      },
      "15": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 32,
          column: 42
        }
      },
      "16": {
        start: {
          line: 35,
          column: 2
        },
        end: {
          line: 38,
          column: 3
        }
      },
      "17": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 36,
          column: 11
        }
      },
      "18": {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 37,
          column: 10
        }
      },
      "19": {
        start: {
          line: 40,
          column: 2
        },
        end: {
          line: 40,
          column: 22
        }
      },
      "20": {
        start: {
          line: 41,
          column: 2
        },
        end: {
          line: 41,
          column: 22
        }
      },
      "21": {
        start: {
          line: 43,
          column: 2
        },
        end: {
          line: 45,
          column: 3
        }
      },
      "22": {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 44,
          column: 21
        }
      },
      "23": {
        start: {
          line: 46,
          column: 2
        },
        end: {
          line: 48,
          column: 3
        }
      },
      "24": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 47,
          column: 21
        }
      },
      "25": {
        start: {
          line: 50,
          column: 2
        },
        end: {
          line: 58,
          column: 3
        }
      },
      "26": {
        start: {
          line: 51,
          column: 4
        },
        end: {
          line: 57,
          column: 5
        }
      },
      "27": {
        start: {
          line: 52,
          column: 6
        },
        end: {
          line: 52,
          column: 23
        }
      },
      "28": {
        start: {
          line: 53,
          column: 6
        },
        end: {
          line: 53,
          column: 23
        }
      },
      "29": {
        start: {
          line: 55,
          column: 6
        },
        end: {
          line: 55,
          column: 23
        }
      },
      "30": {
        start: {
          line: 56,
          column: 6
        },
        end: {
          line: 56,
          column: 23
        }
      },
      "31": {
        start: {
          line: 60,
          column: 2
        },
        end: {
          line: 62,
          column: 3
        }
      },
      "32": {
        start: {
          line: 61,
          column: 4
        },
        end: {
          line: 61,
          column: 24
        }
      },
      "33": {
        start: {
          line: 63,
          column: 2
        },
        end: {
          line: 65,
          column: 3
        }
      },
      "34": {
        start: {
          line: 64,
          column: 4
        },
        end: {
          line: 64,
          column: 24
        }
      },
      "35": {
        start: {
          line: 67,
          column: 2
        },
        end: {
          line: 72,
          column: 3
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 16,
            column: 15
          },
          end: {
            line: 16,
            column: 16
          }
        },
        loc: {
          start: {
            line: 16,
            column: 46
          },
          end: {
            line: 73,
            column: 1
          }
        },
        line: 16
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 22,
            column: 2
          },
          end: {
            line: 24,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 22,
            column: 2
          },
          end: {
            line: 24,
            column: 3
          }
        }, {
          start: {
            line: 22,
            column: 2
          },
          end: {
            line: 24,
            column: 3
          }
        }],
        line: 22
      },
      "1": {
        loc: {
          start: {
            line: 25,
            column: 2
          },
          end: {
            line: 27,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 25,
            column: 2
          },
          end: {
            line: 27,
            column: 3
          }
        }, {
          start: {
            line: 25,
            column: 2
          },
          end: {
            line: 27,
            column: 3
          }
        }],
        line: 25
      },
      "2": {
        loc: {
          start: {
            line: 25,
            column: 6
          },
          end: {
            line: 25,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 25,
            column: 6
          },
          end: {
            line: 25,
            column: 27
          }
        }, {
          start: {
            line: 25,
            column: 31
          },
          end: {
            line: 25,
            column: 47
          }
        }],
        line: 25
      },
      "3": {
        loc: {
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 30,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 30,
            column: 3
          }
        }, {
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 30,
            column: 3
          }
        }],
        line: 28
      },
      "4": {
        loc: {
          start: {
            line: 28,
            column: 6
          },
          end: {
            line: 28,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 28,
            column: 6
          },
          end: {
            line: 28,
            column: 28
          }
        }, {
          start: {
            line: 28,
            column: 32
          },
          end: {
            line: 28,
            column: 49
          }
        }],
        line: 28
      },
      "5": {
        loc: {
          start: {
            line: 31,
            column: 2
          },
          end: {
            line: 33,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 31,
            column: 2
          },
          end: {
            line: 33,
            column: 3
          }
        }, {
          start: {
            line: 31,
            column: 2
          },
          end: {
            line: 33,
            column: 3
          }
        }],
        line: 31
      },
      "6": {
        loc: {
          start: {
            line: 31,
            column: 6
          },
          end: {
            line: 31,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 31,
            column: 6
          },
          end: {
            line: 31,
            column: 28
          }
        }, {
          start: {
            line: 31,
            column: 32
          },
          end: {
            line: 31,
            column: 49
          }
        }],
        line: 31
      },
      "7": {
        loc: {
          start: {
            line: 35,
            column: 2
          },
          end: {
            line: 38,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 35,
            column: 2
          },
          end: {
            line: 38,
            column: 3
          }
        }, {
          start: {
            line: 35,
            column: 2
          },
          end: {
            line: 38,
            column: 3
          }
        }],
        line: 35
      },
      "8": {
        loc: {
          start: {
            line: 35,
            column: 6
          },
          end: {
            line: 35,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 35,
            column: 6
          },
          end: {
            line: 35,
            column: 21
          }
        }, {
          start: {
            line: 35,
            column: 25
          },
          end: {
            line: 35,
            column: 61
          }
        }],
        line: 35
      },
      "9": {
        loc: {
          start: {
            line: 43,
            column: 2
          },
          end: {
            line: 45,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 43,
            column: 2
          },
          end: {
            line: 45,
            column: 3
          }
        }, {
          start: {
            line: 43,
            column: 2
          },
          end: {
            line: 45,
            column: 3
          }
        }],
        line: 43
      },
      "10": {
        loc: {
          start: {
            line: 46,
            column: 2
          },
          end: {
            line: 48,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 46,
            column: 2
          },
          end: {
            line: 48,
            column: 3
          }
        }, {
          start: {
            line: 46,
            column: 2
          },
          end: {
            line: 48,
            column: 3
          }
        }],
        line: 46
      },
      "11": {
        loc: {
          start: {
            line: 50,
            column: 2
          },
          end: {
            line: 58,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 50,
            column: 2
          },
          end: {
            line: 58,
            column: 3
          }
        }, {
          start: {
            line: 50,
            column: 2
          },
          end: {
            line: 58,
            column: 3
          }
        }],
        line: 50
      },
      "12": {
        loc: {
          start: {
            line: 50,
            column: 6
          },
          end: {
            line: 50,
            column: 35
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 50,
            column: 7
          },
          end: {
            line: 50,
            column: 9
          }
        }, {
          start: {
            line: 50,
            column: 13
          },
          end: {
            line: 50,
            column: 15
          }
        }, {
          start: {
            line: 50,
            column: 20
          },
          end: {
            line: 50,
            column: 35
          }
        }],
        line: 50
      },
      "13": {
        loc: {
          start: {
            line: 51,
            column: 4
          },
          end: {
            line: 57,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 51,
            column: 4
          },
          end: {
            line: 57,
            column: 5
          }
        }, {
          start: {
            line: 51,
            column: 4
          },
          end: {
            line: 57,
            column: 5
          }
        }],
        line: 51
      },
      "14": {
        loc: {
          start: {
            line: 60,
            column: 2
          },
          end: {
            line: 62,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 60,
            column: 2
          },
          end: {
            line: 62,
            column: 3
          }
        }, {
          start: {
            line: 60,
            column: 2
          },
          end: {
            line: 62,
            column: 3
          }
        }],
        line: 60
      },
      "15": {
        loc: {
          start: {
            line: 60,
            column: 6
          },
          end: {
            line: 60,
            column: 15
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 60,
            column: 6
          },
          end: {
            line: 60,
            column: 8
          }
        }, {
          start: {
            line: 60,
            column: 12
          },
          end: {
            line: 60,
            column: 15
          }
        }],
        line: 60
      },
      "16": {
        loc: {
          start: {
            line: 61,
            column: 9
          },
          end: {
            line: 61,
            column: 24
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 61,
            column: 18
          },
          end: {
            line: 61,
            column: 20
          }
        }, {
          start: {
            line: 61,
            column: 23
          },
          end: {
            line: 61,
            column: 24
          }
        }],
        line: 61
      },
      "17": {
        loc: {
          start: {
            line: 63,
            column: 2
          },
          end: {
            line: 65,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 63,
            column: 2
          },
          end: {
            line: 65,
            column: 3
          }
        }, {
          start: {
            line: 63,
            column: 2
          },
          end: {
            line: 65,
            column: 3
          }
        }],
        line: 63
      },
      "18": {
        loc: {
          start: {
            line: 63,
            column: 6
          },
          end: {
            line: 63,
            column: 15
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 63,
            column: 6
          },
          end: {
            line: 63,
            column: 8
          }
        }, {
          start: {
            line: 63,
            column: 12
          },
          end: {
            line: 63,
            column: 15
          }
        }],
        line: 63
      },
      "19": {
        loc: {
          start: {
            line: 64,
            column: 9
          },
          end: {
            line: 64,
            column: 24
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 64,
            column: 18
          },
          end: {
            line: 64,
            column: 20
          }
        }, {
          start: {
            line: 64,
            column: 23
          },
          end: {
            line: 64,
            column: 24
          }
        }],
        line: 64
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var PIXEL_STEP = (cov_1ygda8arzu.s[0]++, 10);
var LINE_HEIGHT = (cov_1ygda8arzu.s[1]++, 40);
var PAGE_HEIGHT = (cov_1ygda8arzu.s[2]++, 800);
var DELTA_LENGTH = (cov_1ygda8arzu.s[3]++, 120); // wheelDeltaX, wheelDelta, and wheelDeltaZ have all been removed as they is a deprecated properties on WheelEvents
// https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#typescript-32

export default function (event) {
  cov_1ygda8arzu.f[0]++;
  var sX = (cov_1ygda8arzu.s[4]++, 0);
  var sY = (cov_1ygda8arzu.s[5]++, 0);
  var pX = (cov_1ygda8arzu.s[6]++, 0);
  var pY = (cov_1ygda8arzu.s[7]++, 0);
  cov_1ygda8arzu.s[8]++;

  if ('detail' in event) {
    cov_1ygda8arzu.b[0][0]++;
    cov_1ygda8arzu.s[9]++;
    sY = event.detail;
  } else {
    cov_1ygda8arzu.b[0][1]++;
  }

  cov_1ygda8arzu.s[10]++;

  if ((cov_1ygda8arzu.b[2][0]++, 'wheelDelta' in event) && (cov_1ygda8arzu.b[2][1]++, event.wheelDelta)) {
    cov_1ygda8arzu.b[1][0]++;
    cov_1ygda8arzu.s[11]++;
    sY = -event.wheelDelta / DELTA_LENGTH;
  } else {
    cov_1ygda8arzu.b[1][1]++;
  }

  cov_1ygda8arzu.s[12]++;

  if ((cov_1ygda8arzu.b[4][0]++, 'wheelDeltaY' in event) && (cov_1ygda8arzu.b[4][1]++, event.wheelDeltaY)) {
    cov_1ygda8arzu.b[3][0]++;
    cov_1ygda8arzu.s[13]++;
    sY = -event.wheelDeltaY / DELTA_LENGTH;
  } else {
    cov_1ygda8arzu.b[3][1]++;
  }

  cov_1ygda8arzu.s[14]++;

  if ((cov_1ygda8arzu.b[6][0]++, 'wheelDeltaX' in event) && (cov_1ygda8arzu.b[6][1]++, event.wheelDeltaX)) {
    cov_1ygda8arzu.b[5][0]++;
    cov_1ygda8arzu.s[15]++;
    sX = -event.wheelDeltaX / DELTA_LENGTH;
  } else {
    cov_1ygda8arzu.b[5][1]++;
  }

  cov_1ygda8arzu.s[16]++;

  if ((cov_1ygda8arzu.b[8][0]++, 'axis' in event) && (cov_1ygda8arzu.b[8][1]++, event.axis === event.HORIZONTAL_AXIS)) {
    cov_1ygda8arzu.b[7][0]++;
    cov_1ygda8arzu.s[17]++;
    sX = sY;
    cov_1ygda8arzu.s[18]++;
    sY = 0;
  } else {
    cov_1ygda8arzu.b[7][1]++;
  }

  cov_1ygda8arzu.s[19]++;
  pX = sX * PIXEL_STEP;
  cov_1ygda8arzu.s[20]++;
  pY = sY * PIXEL_STEP;
  cov_1ygda8arzu.s[21]++;

  if ('deltaY' in event) {
    cov_1ygda8arzu.b[9][0]++;
    cov_1ygda8arzu.s[22]++;
    pY = event.deltaY;
  } else {
    cov_1ygda8arzu.b[9][1]++;
  }

  cov_1ygda8arzu.s[23]++;

  if ('deltaX' in event) {
    cov_1ygda8arzu.b[10][0]++;
    cov_1ygda8arzu.s[24]++;
    pX = event.deltaX;
  } else {
    cov_1ygda8arzu.b[10][1]++;
  }

  cov_1ygda8arzu.s[25]++;

  if (((cov_1ygda8arzu.b[12][0]++, pX) || (cov_1ygda8arzu.b[12][1]++, pY)) && (cov_1ygda8arzu.b[12][2]++, event.deltaMode)) {
    cov_1ygda8arzu.b[11][0]++;
    cov_1ygda8arzu.s[26]++;

    if (event.deltaMode === 1) {
      cov_1ygda8arzu.b[13][0]++;
      cov_1ygda8arzu.s[27]++;
      pX *= LINE_HEIGHT;
      cov_1ygda8arzu.s[28]++;
      pY *= LINE_HEIGHT;
    } else {
      cov_1ygda8arzu.b[13][1]++;
      cov_1ygda8arzu.s[29]++;
      pX *= PAGE_HEIGHT;
      cov_1ygda8arzu.s[30]++;
      pY *= PAGE_HEIGHT;
    }
  } else {
    cov_1ygda8arzu.b[11][1]++;
  }

  cov_1ygda8arzu.s[31]++;

  if ((cov_1ygda8arzu.b[15][0]++, pX) && (cov_1ygda8arzu.b[15][1]++, !sX)) {
    cov_1ygda8arzu.b[14][0]++;
    cov_1ygda8arzu.s[32]++;
    sX = pX < 1 ? (cov_1ygda8arzu.b[16][0]++, -1) : (cov_1ygda8arzu.b[16][1]++, 1);
  } else {
    cov_1ygda8arzu.b[14][1]++;
  }

  cov_1ygda8arzu.s[33]++;

  if ((cov_1ygda8arzu.b[18][0]++, pY) && (cov_1ygda8arzu.b[18][1]++, !sY)) {
    cov_1ygda8arzu.b[17][0]++;
    cov_1ygda8arzu.s[34]++;
    sY = pY < 1 ? (cov_1ygda8arzu.b[19][0]++, -1) : (cov_1ygda8arzu.b[19][1]++, 1);
  } else {
    cov_1ygda8arzu.b[17][1]++;
  }

  cov_1ygda8arzu.s[35]++;
  return {
    spinX: sX,
    spinY: sY,
    pixelX: pX,
    pixelY: pY
  };
}